import "./index.css";
import { PaginationContext } from "./context";
import { PageControls } from "./PageControls";
import { PageSizeControls } from "./PageSizeControls";
import type { IPaginationContext, IPaginationProps } from "./types";

export const Pagination = (props: IPaginationProps) => {
  const context: IPaginationContext = props;

  return (
    <PaginationContext value={context}>
      <div className="nuco-pagination">
        <PageSizeControls />
        <PageControls />
      </div>
    </PaginationContext>
  );
};
